import { Observable } from 'rxjs'
import { Action } from 'actions'
import { filter } from 'rxjs/operators'

export const filterRequestOfType = <
  TRequestAction extends Extract<Action, { meta: any }>,
  TActionType extends TRequestAction['type'],
  TActionMeta extends TRequestAction['meta'],
  TAction extends Extract<TRequestAction, { type: TActionType, meta: TActionMeta }>
>
  (filterActionType: TActionType, filterActionMeta: TActionMeta) => (source: Observable<Action>): Observable<TAction> => {
    return source.pipe(
      filter((action): action is TRequestAction => action.type === filterActionType),
      filter((action) => action.meta === filterActionMeta),
    ) as Observable<TAction>
  }

export const filterRequest = <
  TRequestAction extends Extract<Action, { meta: 'request' }>,
  TActionType extends TRequestAction['type'],
  TAction extends Extract<TRequestAction, { type: TActionType, meta: 'request' }>
>
  (actionType: TActionType) => (source: Observable<Action>): Observable<TAction> => {
    return source.pipe(
      filter((action): action is TRequestAction => action.type === actionType && action.meta === 'request')
    ) as Observable<TAction>
  }
